import { createSlice } from "@reduxjs/toolkit";

import { loadTheme } from "./thunks";

import type { ThemeState } from "./types";

const initialState: ThemeState = {};

const themeReducer = createSlice({
  name: "app/themes",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadTheme.fulfilled, (state, action) => {
        state.data = action.payload;
        delete state.errors;
      })
      .addCase(loadTheme.rejected, (state, action) => {
        state.errors = action.payload;
      });
  }
});

export default themeReducer.reducer;
